import client from 'app/client';

export interface GroupContractSignatureStatus {
  /** Vrai si le contrat a été envoyé en signature. */
  signatureSent: boolean;
  /** Vrai si la signature est terminée (contrat passé Actif). */
  isSigned: boolean;
}

interface SendForSignatureResult {
  isSuccess?: boolean;
  errorMessage?: string;
  id?: string;
}

/**
 * Génère le document contractuel du contrat collectif et l'envoie en signature
 * au souscripteur via Signaturit.
 */
export async function sendGroupContractForSignature(
  contractId: string,
): Promise<SendForSignatureResult> {
  const { data } = await client.post<SendForSignatureResult>(
    `/backoffice/contrats/groupes/${contractId}/contrat/signer`,
  );
  return data;
}

/**
 * État de la signature du contrat collectif. Le backend finalise le contrat
 * (passage Actif) si la signature est terminée.
 */
export async function getGroupContractSignatureStatus(
  contractId: string,
): Promise<GroupContractSignatureStatus> {
  const { data } = await client.get<GroupContractSignatureStatus>(
    `/backoffice/contrats/groupes/${contractId}/contrat/signature`,
  );
  return data;
}
